import { OrdineSingolo } from "./OrdineSingolo";
import firebase from 'firebase/app';

export default class Ordine {
    documentId: string;
    data: Date;
    nota: string;
    ordineSingoloList: OrdineSingolo[];
    statoCompletamento: number;
    statoPagamento: number;
    uscitaAttuale?: number;

    constructor() {
        this.documentId = "";
        this.data = new Date();
        this.nota = "";
        this.ordineSingoloList = [];
        this.statoCompletamento = 0;
        this.statoPagamento = 0;
        this.uscitaAttuale = 1;
    }

    static convertFromFirestore(documentId: string, object: firebase.firestore.DocumentData): Ordine {
        let result: Ordine = new Ordine();
        result.documentId = documentId;
        result.data = (object.data as firebase.firestore.Timestamp).toDate();
        result.nota = object.nota;
        result.statoCompletamento = object.statoCompletamento;
        result.statoPagamento = object.statoPagamento;
        object.ordineSingoloList?.forEach((ordine: any) => {
            result.ordineSingoloList.push(OrdineSingolo.convertFromFirestore(ordine));
        });
        result.uscitaAttuale = object.uscitaAttuale;
        return result;
    }

    static convertToFirestore(object: Ordine): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.data = firebase.firestore.Timestamp.fromDate(object.data);
        result.nota = object.nota;
        result.statoCompletamento = object.statoCompletamento;
        result.statoPagamento = object.statoPagamento;
        result.ordineSingoloList = [];
        object.ordineSingoloList.forEach((ordine: any) => {
            result.ordineSingoloList.push(OrdineSingolo.convertToFirestore(ordine));
        });
        result.uscitaAttuale = object.uscitaAttuale;
        return result;
    }

    clone(): Ordine {
        return Ordine.convertFromFirestore(this.documentId, Ordine.convertToFirestore(this));
    }

    getFormattedDateTime(): string {
        let options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return this.data.toLocaleDateString("it-IT", options)
    }
}